import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function SupplierCategory() {
  return (
    <SettingsMetaData propertyName={"SupplierCategory"} viewPropertyName={"Category"} />
  )
}

export default SupplierCategory